// ** React Imports
import { memo, useMemo, useState } from 'react'
// ** Icon Imports
import { Icon } from '@iconify/react'

// ** MUI Imports
import { Box, Tooltip } from '@mui/material'

// ** SCSS Imports
import './index.scss'

const IconifyIcon = ({
  icon = null,
  SvgComponent = null,
  title = '',
  onClick,
  hoverEffect = false,
  hoverBoxStyle = {},
  disabled = false,
  style = {},
  isSvgElement = false,
  ...rest
}) => {
  // State
  const [open, setOpen] = useState(false)

  // variable
  const mergedStyles = useMemo(() => {
    return {
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? 0.5 : 1,
      ...style
    }
  }, [style, disabled])

  // Handers

  const handleClose = () => {
    setOpen(false)
  }

  const handleOpen = () => {
    setOpen(true)
  }

  return (
    <Tooltip
      arrow
      open={open}
      title={title}
      onClose={handleClose}
      onOpen={handleOpen}
    >
      {hoverEffect ? (
        <Box
          className={`icon-hover ${disabled ? 'disabled-icon' : ''}`}
          sx={{
            display: 'flex',
            ...hoverBoxStyle
          }}
          {...(!disabled && onClick
            ? {
                onClick: (e) => {
                  handleClose()
                  onClick(e)
                }
              }
            : {})}
        >
          {SvgComponent ? (
            <Box {...rest}>
              {isSvgElement ? SvgComponent : <SvgComponent />}
            </Box>
          ) : (
            <Icon
              icon={icon}
              fontSize="1.375rem"
              style={mergedStyles}
              {...rest}
            />
          )}
        </Box>
      ) : SvgComponent ? (
        <Box
          className={disabled ? 'disabled-icon' : ''}
          {...(!disabled && onClick
            ? {
                onClick: (e) => {
                  handleClose()
                  onClick(e)
                }
              }
            : {})}
          {...rest}
        >
          {isSvgElement ? SvgComponent : <SvgComponent />}
        </Box>
      ) : (
        <Icon
          icon={icon}
          fontSize="1.375rem"
          style={mergedStyles}
          {...(!disabled && onClick
            ? {
                onClick: (e) => {
                  handleClose()
                  onClick(e)
                }
              }
            : {})}
          {...rest}
        />
      )}
    </Tooltip>
  )
}

export default memo(IconifyIcon)
